import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  LgGridColDirective,
  LgGridContainerDirective,
  LgGridRowDirective
} from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { ComponentLoaderService } from "../../../services/component-loader/component-loader.service";
import { GlobalState } from "../../../store/global/global.reducer";
import { LinkComponent } from "../../globals/Link/Link.component";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { BaseLayoutComponent } from "../BaseLayout/BaseLayout.component";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "dotcom-frontend-sitemap-page",
  templateUrl: "./SitemapLayout.component.html",
  styleUrl: "./SitemapLayout.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    LoaderComponent,
    LgGridRowDirective,
    LgGridContainerDirective,
    LgGridColDirective,
    LinkComponent,
    NgTemplateOutlet
  ]
})
export class SitemapLayoutComponent
  extends BaseLayoutComponent
  implements OnInit
{
  constructor(
    store: Store<{ global: GlobalState }>,
    componentLoaderService: ComponentLoaderService
  ) {
    super(store, componentLoaderService);
  }

  override async ngOnInit() {
    await this.setBreadcrumbs();
  }
}
